import {isEmpty} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';

import {
  ARRAY_SCREENS_WRAPPER,
  TAB_SET_SCREENS_WRAPPER,
} from '../auto_layout_constants';
import ArrayScreenWrapperContainer from './wrappers/ArrayScreenWrapperContainer';
import SingleScreenWrapperContainer from './wrappers/SingleScreenWrapperContainer';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

class ScreensWrapper extends React.PureComponent {
  render() {
    const {
      autoLayoutStateId,
      config,
      configStateId,
      contextParams,
      metadata,
      screenId,
      screenStyles,
    } = this.props;
    const componentType =
      !isEmpty(metadata.getLayout()) && metadata.getLayout().getComponentType()
        ? metadata.getLayout().getComponentType().toLowerCase()
        : null;
    let renderedWrapper = null;

    switch (componentType) {
      case null: {
        break;
      }
      case ARRAY_SCREENS_WRAPPER: {
        renderedWrapper = (
          <ArrayScreenWrapperContainer
            autoLayoutStateId={autoLayoutStateId}
            config={config}
            configStateId={configStateId}
            contextParams={contextParams}
            metadata={metadata}
            screenId={screenId}
            screenStyles={screenStyles}
          />
        );
        break;
      }
      case TAB_SET_SCREENS_WRAPPER: {
        break;
      }
      default:
        renderedWrapper = (
          <SingleScreenWrapperContainer
            autoLayoutStateId={autoLayoutStateId}
            config={config}
            configStateId={configStateId}
            contextParams={contextParams}
            metadata={metadata}
            screenId={screenId}
            screenStyles={screenStyles}
          />
        );
    }
    return <div>{renderedWrapper}</div>;
  }
}

ScreensWrapper.displayName = 'ScreensWrapper';

ScreensWrapper.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  config: PropTypes.objectOf(PropTypes.any).isRequired,
  configStateId: PropTypes.string.isRequired,
  contextParams: PropTypes.objectOf(PropTypes.any).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  screenStyles: PropTypes.objectOf(PropTypes.any),
};

ScreensWrapper.defaultProps = {
  screenStyles: undefined,
};

export default ScreensWrapper;
